module.exports = __webpack_public_path__ + "img/img22.6d2a60b6.svg";